import React, { Component } from 'react';
import { Tag, HTMLTable, InputGroup, Button, Intent, Card, Elevation } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      statusFilter: 'ALL',
      transactions: [
        { id: 'TX-98412', time: '14:42:10', player: 'Merlin', package: '5,000 Silk + Bonus ($50.00)', gateway: 'Credit Card (Visa ****4912)', status: 'SUCCESS' },
        { id: 'TX-98411', time: '14:39:45', player: 'Nozich', package: '10,000 Silk ($100.00)', gateway: 'PayTR 3D Secure', status: 'SUCCESS' },
        { id: 'TX-98410', time: '14:35:12', player: 'GoldCeo', package: '1,000 Silk ($10.00)', gateway: 'Credit Card (Mastercard ****8810)', status: 'INSUFFICIENT_FUNDS' },
        { id: 'TX-98409', time: '14:28:01', player: 'edjka1985', package: '2,500 Silk ($25.00)', gateway: 'Stripe Global', status: 'SUCCESS' },
        { id: 'TX-98408', time: '14:21:19', player: 'FR_Henry', package: '5,000 Silk ($50.00)', gateway: 'Credit Card (Mastercard ****1102)', status: 'CARD_DECLINED' },
        { id: 'TX-98407', time: '14:15:30', player: 'Asviix', package: '1,000 Silk ($10.00)', gateway: 'Maxicard EPIN', status: 'SUCCESS' },
        { id: 'TX-98406', time: '14:10:05', player: 'Sharpknife', package: '500 Silk ($5.00)', gateway: 'PayTR 3D Secure', status: 'SUCCESS' },
        { id: 'TX-98405', time: '14:02:44', player: 'Milaa', package: '10,000 Silk ($100.00)', gateway: 'Crypto USDT (TRC20)', status: 'SUCCESS' },
        { id: 'TX-98404', time: '13:55:18', player: 'QuieTScr3aM', package: '2,500 Silk ($25.00)', gateway: 'Credit Card (Visa ****3049)', status: 'INSUFFICIENT_FUNDS' },
        { id: 'TX-98403', time: '13:48:22', player: '_AntiFire_', package: '1,000 Silk ($10.00)', gateway: 'Stripe Global', status: 'SUCCESS' },
        { id: 'TX-98402', time: '13:41:09', player: 'MasterForce', package: '5,000 Silk ($50.00)', gateway: 'PayTR 3D Secure', status: 'SUCCESS' },
        { id: 'TX-98401', time: '13:30:15', player: '_VulpiX_', package: '500 Silk ($5.00)', gateway: 'Credit Card (Visa ****9921)', status: 'CARD_DECLINED' },
      ],
    };
  }

  renderStatusTag(status) {
    switch (status) {
      case 'SUCCESS':
        return <Tag intent={Intent.SUCCESS} round icon="tick-circle">SUCCESSFUL</Tag>;
      case 'INSUFFICIENT_FUNDS':
        return <Tag intent={Intent.DANGER} round icon="error">INSUFFICIENT FUNDS</Tag>;
      case 'CARD_DECLINED':
        return <Tag intent={Intent.WARNING} round icon="warning-sign">CARD DECLINED</Tag>;
      default:
        return <Tag intent={Intent.NONE} round>{status}</Tag>;
    }
  }

  render() {
    const filtered = this.state.transactions.filter((tx) => {
      const matchSearch = tx.player.toLowerCase().includes(this.state.search.toLowerCase()) ||
        tx.id.toLowerCase().includes(this.state.search.toLowerCase());
      const matchStatus = this.state.statusFilter === 'ALL' || tx.status === this.state.statusFilter;
      return matchSearch && matchStatus;
    });

    return (
      <SideMenuWrapper>
        <div className="mb-3">
          <h3 className="display-4 font-italic mb-2" style={{ fontSize: '1.5rem', color: '#182026' }}>
            Silk Payment & License Transactions Log
          </h3>
          <p className="text-muted" style={{ fontSize: '0.85rem' }}>
            Live stream of Silk purchases and license payments processed through SROFilter Gateway Security.
          </p>
        </div>

        {/* Telemetry Summary Cards */}
        <div className="row mb-4">
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Total Revenue</span>
              <h4 className="m-0 text-success" style={{ fontWeight: 800 }}>$14,890.00</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Success Rate</span>
              <h4 className="m-0 text-info" style={{ fontWeight: 800 }}>96.4%</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Failed Payments</span>
              <h4 className="m-0 text-warning" style={{ fontWeight: 800 }}>12 Tx</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Total Processed</span>
              <h4 className="m-0" style={{ fontWeight: 800, color: '#182026' }}>1,248 Tx</h4>
            </Card>
          </div>
        </div>

        {/* Search & Filter Bar */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex gap-2">
            <Button
              active={this.state.statusFilter === 'ALL'}
              onClick={() => this.setState({ statusFilter: 'ALL' })}
              minimal
              small
              intent={Intent.PRIMARY}
            >
              All (12)
            </Button>
            <Button
              active={this.state.statusFilter === 'SUCCESS'}
              onClick={() => this.setState({ statusFilter: 'SUCCESS' })}
              minimal
              small
              intent={Intent.SUCCESS}
            >
              Successful (8)
            </Button>
            <Button
              active={this.state.statusFilter === 'INSUFFICIENT_FUNDS'}
              onClick={() => this.setState({ statusFilter: 'INSUFFICIENT_FUNDS' })}
              minimal
              small
              intent={Intent.DANGER}
            >
              Insufficient Balance (2)
            </Button>
            <Button
              active={this.state.statusFilter === 'CARD_DECLINED'}
              onClick={() => this.setState({ statusFilter: 'CARD_DECLINED' })}
              minimal
              small
              intent={Intent.WARNING}
            >
              Declined (2)
            </Button>
          </div>

          <div style={{ width: '220px' }}>
            <InputGroup
              leftIcon="search"
              placeholder="Search Player or TX..."
              value={this.state.search}
              onChange={(e) => this.setState({ search: e.target.value })}
              small
            />
          </div>
        </div>

        {/* Transactions Table */}
        <HTMLTable bordered condensed striped interactive style={{ width: '100%', fontSize: '0.82rem' }}>
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>TX ID</th>
              <th style={{ color: '#182026' }}>Time</th>
              <th style={{ color: '#182026' }}>Player Character</th>
              <th style={{ color: '#182026' }}>Silk Package</th>
              <th style={{ color: '#182026' }}>Payment Gateway</th>
              <th style={{ color: '#182026' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((tx, idx) => (
              <tr key={idx}>
                <td className="font-weight-bold" style={{ fontFamily: 'monospace', color: '#182026' }}>{tx.id}</td>
                <td style={{ color: '#5c7080' }}>{tx.time}</td>
                <td className="font-weight-bold" style={{ color: '#106ba3' }}>{tx.player}</td>
                <td style={{ color: '#182026' }}>{tx.package}</td>
                <td style={{ color: '#5c7080' }}>{tx.gateway}</td>
                <td>{this.renderStatusTag(tx.status)}</td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </SideMenuWrapper>
    );
  }
}
